var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDoctor(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 96 96",
    style: {
      enableBackground: "new 0 0 96 96"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M68.695,24.806h-6.074c-1.104,0-2,0.896-2,2s0.896,2,2,2h4.074v6.114c0,6.384-5.194,11.578-11.578,11.578 c-6.384,0-11.578-5.194-11.578-11.578v-6.114h4.074c1.104,0,2-0.896,2-2s-0.896-2-2-2h-6.074c-1.104,0-2,0.896-2,2v8.114 c0,7.911,5.932,14.448,13.578,15.434v6.197c0,6.972-5.672,12.644-12.644,12.644c-4.881,0-9.225-2.762-11.33-7.031 c1.919-1.138,3.213-3.224,3.213-5.613c0-3.599-2.928-6.526-6.526-6.526c-3.599,0-6.526,2.928-6.526,6.526 c0,3.368,2.565,6.147,5.843,6.49c2.585,6.129,8.566,10.154,15.326,10.154c9.178,0,16.644-7.466,16.644-16.644v-6.197 c7.646-0.987,13.578-7.524,13.578-15.434v-8.114C70.695,25.701,69.8,24.806,68.695,24.806z M23.304,56.551 c0-1.393,1.133-2.526,2.526-2.526c1.393,0,2.526,1.134,2.526,2.526s-1.133,2.526-2.526,2.526 C24.438,59.077,23.304,57.943,23.304,56.551z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoctor);
export default __webpack_public_path__ + "static/media/doctor.24b6d03da84d98a076c0dffacac26129.svg";
export { ForwardRef as ReactComponent };